import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "#2C2C2C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.598 9.60156H10.398C9.76153 9.60156 9.15108 9.85442 8.70099 10.3045C8.2509 10.7546 7.99805 11.365 7.99805 12.0016V20.0016C7.99805 20.6381 8.2509 21.2485 8.70099 21.6986C9.15108 22.1487 9.76153 22.4016 10.398 22.4016H21.598C22.2346 22.4016 22.845 22.1487 23.2951 21.6986C23.7452 21.2485 23.998 20.6381 23.998 20.0016V12.0016C23.998 11.365 23.7452 10.7546 23.2951 10.3045C22.845 9.85442 22.2346 9.60156 21.598 9.60156V9.60156ZM10.398 11.2016H21.598C21.8102 11.2016 22.0137 11.2858 22.1637 11.4359C22.3138 11.5859 22.398 11.7894 22.398 12.0016L15.998 15.9056L9.59805 12.0016C9.59805 11.7894 9.68233 11.5859 9.83236 11.4359C9.98239 11.2858 10.1859 11.2016 10.398 11.2016V11.2016ZM22.398 20.0016C22.398 20.2137 22.3138 20.4172 22.1637 20.5672C22.0137 20.7173 21.8102 20.8016 21.598 20.8016H10.398C10.1859 20.8016 9.98239 20.7173 9.83236 20.5672C9.68233 20.4172 9.59805 20.2137 9.59805 20.0016V13.8256L15.582 17.4816C15.7037 17.5518 15.8416 17.5887 15.982 17.5887C16.1225 17.5887 16.2604 17.5518 16.382 17.4816L22.398 13.8256V20.0016Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
